import React, { useEffect, useState, ReactNode } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import SvgIcon from "@mui/material/SvgIcon";
import { Typography, Box, Link } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import AppHeader from "../AppHeader/AppHeader";
import { ReactComponent as GlobalSvg } from "../../media/Icons/globe.svg";
import { ROUTE_LINKS } from "../../routes";
import { TopSection } from "./styles";
import { useTheme } from "@mui/system";
import { useChainbridge } from "../../contexts/ChainbridgeContext/ChainbridgeContext";

interface IAppWrapper {
  children: ReactNode | ReactNode[];
  wrapTokenPage?: boolean;
}

const AppWrapper: React.FC<IAppWrapper> = ({
  children,
  wrapTokenPage,
}: IAppWrapper) => {
  const [enableNavTabs, setEnableNavTabs] = useState(true);
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { homeConfig } = useChainbridge();

  useEffect(() => {
    navigate("/transfer");
  }, []);

  useEffect(() => {
    return setEnableNavTabs(true);
  }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <>
        {enableNavTabs ? (
          <Box
            component="div"
            display="flex"
            flexDirection="column"
            paddingTop={theme.spacing(30)}
            height="100%"
            sx={{
              [theme.breakpoints.down("md")]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                paddingTop: homeConfig ? theme.spacing(36) : theme.spacing(30),
              },
            }}
          >
            <AppHeader />
            <Box display="flex" flex="2">
              <TopSection>
                {enableNavTabs && (
                  <Box>
                    <Link
                      component={NavLink}
                      to={ROUTE_LINKS.Transfer}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "#fff",
                        mb: theme.spacing(5),
                        textDecoration: "none",
                      }}
                    >
                      <SvgIcon>
                        <GlobalSvg />
                      </SvgIcon>
                      <Typography
                        variant="h1"
                        ml={theme.spacing(3)}
                        fontSize="24px"
                        fontWeight="700"
                        color={theme.palette.text.primary}
                      >
                        Transfer
                      </Typography>
                    </Link>
                  </Box>
                )}
                {children}
              </TopSection>
            </Box>
            <Box
              padding="16px 0 36px 60px"
              fontSize="14px"
            >
              v{process.env.VERSION || 'DEV'}
            </Box>
            {/* Put CTA here */}
            {/* <a rel="noopener noreferrer" target="_blank" href="#">
        </a> */}
          </Box>
        ) : (
          <Box component="main">
            <AppHeader />
            <div>{children}</div>
          </Box>
        )}
      </>
    </ThemeProvider>
  );
};

export default AppWrapper;
